import React, { useState } from "react";

const PromoForm = ({ onSubmit }) => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
  });

  return (
    <div className="bg-white max-w-3xl w-full grid grid-cols-2">
      <div className="p-10">
        <h2 className="text-2xl font-bold mb-4">
          Diskon 10% s/d Rp 50.000,-
        </h2>

        {["name", "email", "phone"].map((field) => (
          <input
            key={field}
            placeholder={
              field === "name"
                ? "Nama"
                : field === "email"
                ? "Email"
                : "No HP"
            }
            className="w-full border-b mb-4 p-2"
            onChange={(e) =>
              setForm({ ...form, [field]: e.target.value })
            }
          />
        ))}

        <button
          onClick={() => onSubmit(form)}
          className="bg-black text-white w-full py-3 font-bold mt-4"
        >
          DAFTAR
        </button>
      </div>

      <div className="bg-red-600 text-white flex items-center justify-center font-bold text-2xl">
        SPAREPART <br /> & AKSESORIS
      </div>
    </div>
  );
};

export default PromoForm;
